import common from '@/mixin/common'
import plugins from '@/components/index'
export default {
    install: function (Vue) {
        //全局混入
        Vue.mixin(common)
        // 全局注册一些组件
        Vue.use(plugins)
    }
}